export default __webpack_public_path__ + "static/media/GT.2d88d17a.svg";